// @ts-ignore
 
import request from "src/lib/axios";

/** e签宝：签署流程异步通知 接收 signFlowConfig.notifyUrl 推送；服务端验签后调用开放平台查询签署详情，再更新订单签署状态。成功请返回 HTTP 2xx。 POST /api/v1/esign/sign-completed-notify */
export async function EsignControllerSignCompletedNotifyV1(options?: {
  [key: string]: any;
}) {
  return request<any>("/api/v1/esign/sign-completed-notify", {
    method: "POST",
    ...(options || {}),
  });
}
